/*
 * Cleverroute
 * Cleverroute API
 *
 * OpenAPI spec version: 0.0.2
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.36
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from "../ApiClient";
import {ResponseStatus} from '../model/ResponseStatus';
import {Transport} from '../model/Transport';
import {VehicleSpec} from '../model/VehicleSpec';

/**
* Config service.
* @module api/ConfigApi
* @version 0.0.2
*/
export class ConfigApi {

    /**
    * Constructs a new ConfigApi. 
    * @alias module:api/ConfigApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Callback function to receive the result of the modifySpecOfVehiclesOfUser operation.
     * @callback moduleapi/ConfigApi~modifySpecOfVehiclesOfUserCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseStatus{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {String} userId should be removed once extracting userId from token, as it wouldnt be necessary then
     * @param {Object} opts Optional parameters
     * @param {Array.<module:model/VehicleSpec>} opts.body change specification of vehicle-types (e.g. car, etc.)
     * @param {module:api/ConfigApi~modifySpecOfVehiclesOfUserCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    modifySpecOfVehiclesOfUser(userId, opts, callback) {
      opts = opts || {};
      let postBody = opts['body'];
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling modifySpecOfVehiclesOfUser");
      }

      let pathParams = {
        
      };
      let queryParams = {
        'userId': userId
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['myOAuth2'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = ResponseStatus;

      return this.apiClient.callApi(
        '/config/vehiclesOfUser', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the modifyUsageOfTransportsOfUser operation.
     * @callback moduleapi/ConfigApi~modifyUsageOfTransportsOfUserCallback
     * @param {String} error Error message, if any.
     * @param {module:model/ResponseStatus{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {String} userId should be removed once extracting userId from token, as it wouldnt be necessary then
     * @param {Object} opts Optional parameters
     * @param {Array.<module:model/Transport>} opts.body change usage of transport variants (e.g. park-and-ride), vehicle-types (e.g. car, etc.) and providers (e.g. Regio.mobil) of user to &#x27;used&#x27; or &#x27;not used&#x27;
     * @param {module:api/ConfigApi~modifyUsageOfTransportsOfUserCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    modifyUsageOfTransportsOfUser(userId, opts, callback) {
      opts = opts || {};
      let postBody = opts['body'];
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling modifyUsageOfTransportsOfUser");
      }

      let pathParams = {
        
      };
      let queryParams = {
        'userId': userId
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['myOAuth2'];
      let contentTypes = ['application/json'];
      let accepts = ['application/json'];
      let returnType = ResponseStatus;

      return this.apiClient.callApi(
        '/config/transportsOfUser', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the transportsByInstanceId operation.
     * @callback moduleapi/ConfigApi~transportsByInstanceIdCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/Transport>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * get all transport definitions of a instance by its id
     * @param {String} instanceId instanceId
     * @param {module:api/ConfigApi~transportsByInstanceIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    transportsByInstanceId(instanceId, callback) {
      
      let postBody = null;
      // verify the required parameter 'instanceId' is set
      if (instanceId === undefined || instanceId === null) {
        throw new Error("Missing the required parameter 'instanceId' when calling transportsByInstanceId");
      }

      let pathParams = {
        
      };
      let queryParams = {
        'instanceId': instanceId
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['myOAuth2'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [Transport];

      return this.apiClient.callApi(
        '/config/transportsByInstanceId', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the transportsOfUser operation.
     * @callback moduleapi/ConfigApi~transportsOfUserCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/Transport>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * get all transport definitions of the logged in user
     * @param {String} userId should be removed once extracting userId from token, as it wouldnt be necessary then
     * @param {Object} opts Optional parameters
     * @param {String} opts.instanceId instanceId will be used to retrieve instance related transports if user didn&#x27;t modify his one
     * @param {module:api/ConfigApi~transportsOfUserCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    transportsOfUser(userId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling transportsOfUser");
      }

      let pathParams = {
        
      };
      let queryParams = {
        'userId': userId,'instanceId': opts['instanceId']
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['myOAuth2'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [Transport];

      return this.apiClient.callApi(
        '/config/transportsOfUser', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
    /**
     * Callback function to receive the result of the vehiclesOfUser operation.
     * @callback moduleapi/ConfigApi~vehiclesOfUserCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/VehicleSpec>{ data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * get all vehicles definitions of the logged in user
     * @param {String} userId should be removed once extracting userId from token, as it wouldnt be necessary then
     * @param {Object} opts Optional parameters
     * @param {String} opts.instanceId instanceId will be used to retrieve instance related vehicles if user didn&#x27;t modify his one
     * @param {module:api/ConfigApi~vehiclesOfUserCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link <&vendorExtensions.x-jsdoc-type>}
     */
    vehiclesOfUser(userId, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'userId' is set
      if (userId === undefined || userId === null) {
        throw new Error("Missing the required parameter 'userId' when calling vehiclesOfUser");
      }

      let pathParams = {
        
      };
      let queryParams = {
        'userId': userId,'instanceId': opts['instanceId']
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = ['myOAuth2'];
      let contentTypes = [];
      let accepts = ['application/json'];
      let returnType = [VehicleSpec];

      return this.apiClient.callApi(
        '/config/vehiclesOfUser', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

}